<h2 class="seller-payment-pending-dialog__title" id="seller-payment-dialog-title" mat-dialog-title>
  @if (mode === "pix") {
    Cobrança PIX
  } @else {
    Link de pagamento (cartão)
  }
</h2>

<mat-dialog-content class="seller-payment-pending-dialog__body">
  @if (state$ | async; as st) {
    @if (st.statusText === "PAGO" || st.statusText === "FALHOU") {
      <div
        class="seller-payment-pending-dialog__status"
        aria-live="polite"
        role="status"
        [class.seller-payment-pending-dialog__status--ok]="st.statusText === 'PAGO'"
        [class.seller-payment-pending-dialog__status--err]="st.statusText === 'FALHOU'">
        <span class="seller-payment-pending-dialog__status-text">{{ st.statusText }}</span>
      </div>
    }

    @if (
      st.statusText === "AGUARDANDO PAGAMENTO" || st.statusText === "Pendente pagamento"
    ) {
      <div
        class="seller-payment-pending-dialog__awaiting"
        role="status"
        aria-label="Aguardando pagamento">
        <div class="seller-payment-pending-dialog__awaiting-top">
          <p-progressSpinner
            class="seller-payment-pending-dialog__spinner"
            [style]="{ width: '32px', height: '32px' }"
            strokeWidth="3"
            animationDuration="0.8s" />
        </div>
        <p class="seller-payment-pending-dialog__awaiting-label">Aguardando confirmação do pagamento</p>
        <p
          class="seller-payment-pending-dialog__awaiting-ws"
          [class.seller-payment-pending-dialog__awaiting-ws--on]="st.isWebSocketConnected">
          <i class="fas fa-broadcast-tower" aria-hidden="true"></i>
          {{
            st.isWebSocketConnected
              ? "Acompanhamento em tempo real ativo"
              : "Sincronizando em segundo plano…"
          }}
        </p>
      </div>
    }
  }

  @if (mode === "pix" && pixData) {
    <p class="seller-payment-pending-dialog__intro">
      Exiba o QR Code ou envie o código copia e cola ao comprador.
    </p>
    <div class="seller-payment-pending-dialog__amount">
      <span class="seller-payment-pending-dialog__amount-label">Valor</span>
      <span class="seller-payment-pending-dialog__amount-value">{{ pixData.amount | currency: "BRL" }}</span>
    </div>
    <div class="seller-payment-pending-dialog__qr" aria-hidden="true">
      <qr-code
        [value]="pixData.qr_code"
        [size]="168"
        errorCorrectionLevel="M" />
    </div>
    <div class="seller-payment-pending-dialog__field">
      <label class="form-label" for="dlg-pix-copy">PIX copia e cola</label>
      <input
        id="dlg-pix-copy"
        type="text"
        class="form-control seller-payment-pending-dialog__input"
        [value]="pixData.qr_code"
        readonly
        title="Código Pix copia e cola" />
      <app-button (btnClick)="copyPixCode()">
        <i class="fas fa-copy" aria-hidden="true"></i>
        Copiar código
      </app-button>
    </div>
  }

  @if (mode === "payment_link" && paymentLinkUrl) {
    <p class="seller-payment-pending-dialog__intro">
      Compartilhe o link; quando o cartão for aprovado, a confirmação aparece aqui.
    </p>
    <div class="seller-payment-pending-dialog__field">
      <label class="form-label" for="dlg-link">Link de pagamento</label>
      <input
        id="dlg-link"
        class="form-control seller-payment-pending-dialog__input"
        type="url"
        [value]="paymentLinkUrl"
        readonly
        title="URL do link de pagamento" />
      <div class="seller-payment-pending-dialog__link-actions">
        <app-button (btnClick)="copyLink()">
          <i class="fas fa-copy" aria-hidden="true"></i>
          Copiar link
        </app-button>
        <app-button (btnClick)="openLinkInNewTab()">
          <i class="fas fa-external-link-alt" aria-hidden="true"></i>
          Abrir em nova aba
        </app-button>
      </div>
    </div>
  }
</mat-dialog-content>

<mat-dialog-actions class="seller-payment-pending-dialog__actions" align="end">
  <app-button styleType="outlined" (btnClick)="onRequestClose()">Fechar</app-button>
</mat-dialog-actions>
